module.exports = __webpack_public_path__ + "assets/img/MI-RMI422-AW-020-2.ef4dba05.jpg";